import { $http, $https } from '@/utils';
import $config from '@/config';
const _iotCenter = true ? '/iot-center' : '';
const _account = true ? '/account' : '';

// eslint-disable-next-line import/no-anonymous-default-export
export default {

    //获取验证码图片
    getPictrueCode(data) {
        const _params = {
            url: _account + '/code' + (data ? ('/' + data) : ''),
            method: 'GET'
        };
        return $https(_params);
    },

    // 登录
    login(data) {
        const _params = {
            url: '/authentication/auth/login',
            data: {
                ...data,
                platType: $config.platType
            },
            method: 'POST',
        };
        return $https(_params);
    },

    //获取个人信息
    getUserInfo() {
        return $http.get(_account + '/getInfo');
    },
    getRouters(data) {
        return $http.get(_account + '/getRouters',data);
    },
    // 退出
    loginOut() {
        return $http.post(_account + '/oauth/logout');
    },


    //获取采集点类型列表-树的1级  查询采集点分组
    getCollectPointTypes() {
        return $http.get(_iotCenter + '/tree/collect/queryGroup');
    },


    //查询分组的下的一级采集点列表
    getOrgDeviceTreeData(data) {
        return $http.get(_iotCenter + '/tree/collect/point/code', data);
    },


    //根据区域code查询区域  -  搜索
    getOrgDeviceTreeDataSearch(data) {
        return $http.get(_iotCenter + '/tree/collect/point/search', data);
    },

    //字典
    getDictItem() {
        return $http.get(_iotCenter + '/dictItem');
    },

    //新增网关设备
    addGetway(data){
        return $http.put(_iotCenter + '/collect/point/device/gateway/add', data);
    },
    //新增电表
    addMeter(data){
        return $http.put(_iotCenter + '/collect/point/device/meter/add', data);
    },
    //查询字典
    getProtocolList(dictCode){
        return $http.get('/archive/dictItem', {dictCode});
    },
    //查询所有的产品型号
    getProductList(dictCode){
        return $http.get(_iotCenter + '/collect/point/device/all/product', {dictCode});
    },
    //根据资产号获取信息
    getAssetCodeInfo(assetBarcode){
        return $http.get('/scm/materials/findDetailByAssetBarcode/'+assetBarcode ,{});
    },
    //解绑电表
    delMeter(data){
        return $http.put(_iotCenter + '/device/meter/unbind/'+data);
    },
    //解绑集中区
    delGetway(data){
        return $http.put(_iotCenter + '/device/terminalUnbind/'+data);
    },
}
